import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './PaymentLoadingModal.css'
import '../../../assets/css/modal.css'
import { dataContext } from '../../../App';
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from 'react-router-dom';
const PaymentLoadingModal = ({ showPaymentLoadingModal, setShowPaymentLoadingModal,setToggleToUpdate,toggleToUpdate,activeBottom }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  let navigate = useNavigate();

  function hideModalOperation() {
    setShowPaymentLoadingModal(false)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      console.log("processing payment");
      setToggleToUpdate((prev) => !prev)
    }, 8000);
    const secondTimer = setTimeout(() => {
      setToggleToUpdate((prev) => !prev)
      setShowPaymentLoadingModal(false)
      if(activeBottom === "campaign"){
        navigate("../");
      }
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(secondTimer);
    }
  }, [])


  return (
    <>
      <Modal show={showPaymentLoadingModal} centered dialogClassName="modal-dialog" contentClassName="modalContent" onHide={hideModalOperation}>
        <Modal.Header >
          <Modal.Title>Payment Processing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Spinner animation="border" className='loadingSpinner' />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PaymentLoadingModal